import { render, staticRenderFns } from "./TargetCapacity.vue?vue&type=template&id=3bfc741e&scoped=true"
import script from "./TargetCapacity.vue?vue&type=script&lang=js"
export * from "./TargetCapacity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfc741e",
  null
  
)

export default component.exports